//
//
//
//
//
//
//

let Centrifuge = require("centrifuge");
import axios from 'axios';
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default {
  name: 'Refresher',
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    balance() {
      if (_.has(this.user, 'balance')) {
        return this.format_money(_.get(this.user, 'balance'), _.get(this.user, 'currency'))
      }
      return null;
    },
    selections() {
      return this.$store.state.selections
    },
    jwt() {
      return this.$store.state.auth.jwt
    },
    statId() {
      return this.$store.state.statId
    }
  },
  async mounted() {
    window.axios = axios

    this.$store.commit('auth/setJwt', localStorage.getItem('jwt'))


    this.$root.$on('update_balance', () => {
      this.getBalance()
    })

    if (tock.active('sports')) {
      tock.clear('sports')
    }
    tock.setInterval(
      'sports',
      () => {
        this.fetchSports()
      },
      50 * 1000
    )

    setTimeout(() => {

      (function (a, b, c, d, e, f, g, h, i) {
        a[e] || (i = a[e] = function () { (a[e].q = a[e].q || []).push(arguments) }, i.l = 1 * new Date, i.o = f,
          g = b.createElement(c), h = b.getElementsByTagName(c)[0], g.async = 1, g.src = d, g.setAttribute("n", e), h.parentNode.insertBefore(g, h)
        )
      })(window, document, "script", "https://widgets.sir.sportradar.com/e96f9c55e3128ef5a14a38b5d158ae10/widgetloader", "SIR", {
        theme: false, // using custom theme
        language: this.getLang()
      });

      if (tock.active('sportradarActive')) {
        tock.clear('sportradarActive')
      }

      tock.setInterval('sportradarActive', () => {
        if (!_.isUndefined(window.SIR)) {
          this.$store.commit('setSportradarActive', true)
          tock.clear('sportradarActive')
        }
      }, 1000)

    }, 1000)

    try {
      if (!this.$store.state.settings.timezone) {
        this.$store.commit('settings/setTimezone', Intl.DateTimeFormat().resolvedOptions().timeZone)
      }
    } catch (e) {
      console.log('catch e', e)
    }

    const centrifuge = new Centrifuge(this.$config.PUBSUB_URL);
    centrifuge.on('connect', function (connectCtx) {
      console.log('connected', connectCtx)
    });
    centrifuge.on('disconnect', function (disconnectCtx) {
      console.log('disconnected', disconnectCtx)
    });
    centrifuge.subscribe('bet777_events', function (message) {
      //console.log(new Date().toLocaleTimeString(), _.get(message, 'data.events'));
      emitter.emit('events', _.get(message, 'data.events'))
    })
    centrifuge.connect();

    this.$i18n.onLanguageSwitched = (oldLocale, newLocale) => {
      this.fetchSports()
    }

    try {
      let device = await this.$CapacitorDevice.getInfo()
      this.$store.commit('setPlatform', _.get(device, 'platform'))

    } catch (e) { }

    if (tock.active('cashouts')) {
      tock.clear('cashouts')
    }
    tock.setInterval(
      'cashouts',
      () => {
        this.checkCashouts()
      },
      3 * 1000
    )
    if (tock.active('getBalance')) {
      tock.clear('getBalance')
    }
    tock.setInterval(
      'getBalance',
      () => {
        this.getBalance()
      },
      30 * 1000
    )
    await this.getBalance();

    await this.refreshSession();
    try {
      document.onclick = (e) => {
        const link = e.target.closest('a')
        if (link && link.hostname && link.hostname !== window.location.hostname) {
          return
        }
        this.refreshSession()
      }
      document.onkeyup = () => { this.refreshSession() }
      document.ontouchend = () => { this.refreshSession() }

    } catch (error) {
      console.error(error)
    }

    await this.fetchLocation()

    await this.fetchDevice();


  },
  methods: {
    getLang() {
      if(this.lang === 'in') {
        return 'en'
      }
      return this.lang
    },
    async fetchDevice() {
      try {
        const fpPromise = FingerprintJS.load({ monitoring: false })
        const fp = await fpPromise
        const result = await fp.get()
        this.$store.commit('setDeviceFingerprint', result.visitorId)
      } catch (e) {
        console.log('setDeviceFingerprint', e)
      }
    },
    async fetchLocation() {
      try {
        let result = await this.$auth().get('/api/common/get-location', {})
        console.log('fetchLocation', result, _.get(result, 'data.restriction.location_allowed'));
        if (!_.get(result, 'data.restriction.location_allowed'))
          this.$store.commit('setLocationAllowed', false)
      } catch (e) {

      }
    },
    async updateSession() {
      if (!this.user) {
        return
      }

      await axios({
        method: "post",
        withCredentials: true,
        url: this.$config.CASINO_API + '/register/cross_login',
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      })

      try {
        let result = await this.$auth().get('/api/common/get-balance', {})
        this.$store.commit('auth/setJwt', _.get(data, 'jwt'))
        await this.getBalance();
      } catch (e) {
        let data = _.get(e, 'response.data')
        console.log('get-balance', data)
      }
    },
    async checkCashouts() {

      if (_.size(this.$store.state.cashoutHistory) == 0) {
        return;
      }

      try {
        const response = await this.$api().$get('/v1/bets/cashouts', {});
        let cashoutHistory = this.$store.state.cashoutHistory;
        let bets = _.map(_.get(response, 'cashouts'), 'bet_id');
        if (_.intersection(cashoutHistory, bets).length) {
          //remove from history the ones completed
          this.$store.commit('setCashoutHistory', _.difference(cashoutHistory, _.intersection(cashoutHistory, bets)))
          this.$notyf.success(this.$t('Cashout(s) successfully processed'))
        }
      } catch (e) {

      }
    }
  }
}
